import toast from 'helpers/toast';
import { FetchError } from 'public-api/codegen/base';
import { getFieldErrors, isResponse } from 'public-api/utils';

export default async function getFormErrors(error: unknown): Promise<Record<string, string>> {
  if (isResponse(error) && error.response.status === 400) {
    const { other, non_field_errors: nonFieldErrors, detail, ...fields } = await getFieldErrors(error);
    const generalErrors = [other, nonFieldErrors, detail].filter(Boolean);
    if (generalErrors.length) toast.error(generalErrors.join(' '));
    if (generalErrors.length || Object.keys(fields).length) return fields;
  }

  let message: string;
  if (error instanceof FetchError) {
    message = gettext('Unable to connect to Retino. Check your internet connection and try again.');
  } else {
    message = gettext('We could not complete your request. Please contact support if the problem persists.');
    if (isResponse(error)) {
      message += ` (HTTP ${error.response.status})`;
      const requestId = error.response.headers.get('X-Request-Id');
      if (requestId) {
        message += ` ${interpolate(gettext('Request ID: %(id)s'), { id: requestId }, true)}`;
      }
    }
  }
  toast.error(message);
  return {};
}
